"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatConcentration = void 0;
const uuid_1 = require("uuid");
const formatConcentration = ({ borrowingBaseReportId, concentrationLimitCalculationResults, timestamp, }) => concentrationLimitCalculationResults.map((result) => ({
    ...result,
    id: (0, uuid_1.v4)(),
    borrowingBaseReportId,
    created_at: timestamp,
    updated_at: timestamp,
}));
exports.formatConcentration = formatConcentration;
//# sourceMappingURL=concentration.js.map